// extracted by mini-css-extract-plugin
export default {"title":"_3dd1a15012","inner_title":"_1460ca16a1","charge_btn":"e42e75f29b"};